import { render, staticRenderFns } from "./manage-model.vue?vue&type=template&id=490288aa&scoped=true&"
import script from "./manage-model.vue?vue&type=script&lang=js&"
export * from "./manage-model.vue?vue&type=script&lang=js&"
import style0 from "./manage-model.vue?vue&type=style&index=0&id=490288aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490288aa",
  null
  
)

export default component.exports